import type { StorageUsage } from '@trove/contracts';
import {
  storagePressure,
  storageRatio,
  storageUsageLabel,
  type StoragePressure,
} from '../storageUsage';
import styles from './StorageMeter.module.css';

export function StorageMeter({
  usage,
  compact = false,
}: {
  usage: StorageUsage | undefined;
  compact?: boolean;
}) {
  const pressure: StoragePressure = usage ? storagePressure(usage) : 'ok';
  const ratio = usage ? storageRatio(usage) : 0;

  return (
    <div className={`${styles.meter} ${compact ? styles.compact : ''}`}>
      <div className={styles.value}>{usage ? storageUsageLabel(usage) : '…'}</div>
      <div
        className={`${styles.track} ${styles[`pressure_${pressure}`] ?? ''}`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(ratio * 100)}
        aria-label="Encrypted storage used"
      >
        <div className={styles.fill} style={{ width: `${Math.min(100, ratio * 100)}%` }} />
      </div>
    </div>
  );
}
